// extracted by mini-css-extract-plugin
module.exports = {"EmployeeImage":"EmployeeImage__EmployeeImage___LfEUz"};